import { FaSeedling } from "react-icons/fa";
import IconNorskTipping from "../../../themes/icons/NorskTipping";
import ButtonTomatoClose from "../../ui/buttons/ButtonTomatoClose";
import ButtonTutorial from "../../ui/buttons/ButtonTutorial";
import styles from "./Learn.module.scss";
import { useSearchParams } from "react-router-dom";

function Learn({ onClick }) {
  const [searchParams] = useSearchParams();

  const version = searchParams.get("version");

  const handleClose = () => {
    onClick("null");
  };

  const handleChange = (val) => {
    onClick(val);
  };

  return (
    <div className={`${styles["background"]} ${styles["background--1"]}`}>
      <div className={`${styles["foreground"]} ${styles["foreground--1"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["intro"]}>
          <p>
            <b className={styles["color--green-dark"]}>Welcome!</b> This section contains
            interactive guides to help you familiarize with Tomato. Have in mind, that all tutorials
            are also available in text format or video guides. Don't forget to check the{" "}
            <a
              href="https://testify.no/en/tomato-en/tutorials-en/"
              target="_blank"
              className={styles["address"]}
              rel="noreferrer">
              web site.
            </a>
          </p>
        </div>
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            {version === "norsktipping" ? (
              <ButtonTutorial
                theme="green"
                icon={<IconNorskTipping />}
                title="Norsk Tipping"
                subtitle="Dedicated workshop tutorial"
                onClick={() => handleChange("dNT0")}
              />
            ) : null}
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="How to create your first function"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/how-to-create-your-first-function/"
              onClick={() => handleChange("firstFunction0")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Global parameters"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/global-parameters/"
              onClick={() => handleChange("globalParameters0")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Logic"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/logic/"
              onClick={() => handleChange("logic0")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Output parameters"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/output-parameters/"
              onClick={() => handleChange("output0")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Abstract choices and values"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/choice-hierarchy-values-and-labels/"
              onClick={() => handleChange("hav0")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Labels"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/choice-hierarchy-values-and-labels/"
              onClick={() => handleChange("label0")}
            />
            <ButtonTutorial
              theme="green"
              icon={<FaSeedling />}
              title="Structures"
              subtitle="Text version:"
              address="https://testify.no/en/tomato-en/tutorials-en/structures/"
              onClick={() => handleChange("struct0")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Learn;
